import PropTypes from 'prop-types';
export default () => PropTypes.arrayOf(PropTypes.shape({
    layout: PropTypes.string,
    name: PropTypes.string.isRequired,
    visible: PropTypes.bool.isRequired,
    width: PropTypes.string,
    offset: PropTypes.string,
}));
//# sourceMappingURL=device-breakpoints.js.map